var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 5H6.6C6.03995 5 5.75992 5 5.54601 5.10899C5.35785 5.20487 5.20487 5.35785 5.10899 5.54601C5 5.75992 5 6.03995 5 6.6V10.4C5 10.9601 5 11.2401 5.10899 11.454C5.20487 11.6422 5.35785 11.7951 5.54601 11.891C5.75992 12 6.03995 12 6.6 12H10.4C10.9601 12 11.2401 12 11.454 11.891C11.6422 11.7951 11.7951 11.6422 11.891 11.454C12 11.2401 12 10.9601 12 10.4V6.6C12 6.03995 12 5.75992 11.891 5.54601C11.7951 5.35785 11.6422 5.20487 11.454 5.10899C11.2401 5 10.9601 5 10.4 5Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 5H17.6C17.0399 5 16.7599 5 16.546 5.10899C16.3578 5.20487 16.2049 5.35785 16.109 5.54601C16 5.75992 16 6.03995 16 6.6V10.4C16 10.9601 16 11.2401 16.109 11.454C16.2049 11.6422 16.3578 11.7951 16.546 11.891C16.7599 12 17.0399 12 17.6 12H21.4C21.9601 12 22.2401 12 22.454 11.891C22.6422 11.7951 22.7951 11.6422 22.891 11.454C23 11.2401 23 10.9601 23 10.4V6.6C23 6.03995 23 5.75992 22.891 5.54601C22.7951 5.35785 22.6422 5.20487 22.454 5.10899C22.2401 5 21.9601 5 21.4 5Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 16H17.6C17.0399 16 16.7599 16 16.546 16.109C16.3578 16.2049 16.2049 16.3578 16.109 16.546C16 16.7599 16 17.0399 16 17.6V21.4C16 21.9601 16 22.2401 16.109 22.454C16.2049 22.6422 16.3578 22.7951 16.546 22.891C16.7599 23 17.0399 23 17.6 23H21.4C21.9601 23 22.2401 23 22.454 22.891C22.6422 22.7951 22.7951 22.6422 22.891 22.454C23 22.2401 23 21.9601 23 21.4V17.6C23 17.0399 23 16.7599 22.891 16.546C22.7951 16.3578 22.6422 16.2049 22.454 16.109C22.2401 16 21.9601 16 21.4 16Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 16H6.6C6.03995 16 5.75992 16 5.54601 16.109C5.35785 16.2049 5.20487 16.3578 5.10899 16.546C5 16.7599 5 17.0399 5 17.6V21.4C5 21.9601 5 22.2401 5.10899 22.454C5.20487 22.6422 5.35785 22.7951 5.54601 22.891C5.75992 23 6.03995 23 6.6 23H10.4C10.9601 23 11.2401 23 11.454 22.891C11.6422 22.7951 11.7951 22.6422 11.891 22.454C12 22.2401 12 21.9601 12 21.4V17.6C12 17.0399 12 16.7599 11.891 16.546C11.7951 16.3578 11.6422 16.2049 11.454 16.109C11.2401 16 10.9601 16 10.4 16Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.0f28fdced3f5f5ffcc00002c0b0f3bfe.svg";
export { ForwardRef as ReactComponent };